// extracted by css-extract-rspack-plugin
export default {"user-menu":"user-menu-tNHfs","userMenu":"user-menu-tNHfs","share-icon":"share-icon-h2jtB","shareIcon":"share-icon-h2jtB"};